import { Dialog as DrawerPrimitive } from "radix-ui";

export const DrawerTrigger = DrawerPrimitive.Trigger;
